// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { Credential } from '@daml.js/dtc-credential/lib/Dtc/Credential/V3/Credential';
import { ClientOnboarderService } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/ClientOnboarder/module';
import { DenyList } from '@daml.js/dtc-registry/lib/Dtc/Registry/V3/Rbac/Deny';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

type RemoveWalletsFromDenyListArgs = {
  clientOnboarderServiceCid: ContractId<ClientOnboarderService>;
  denyListCid: ContractId<DenyList>;
  credentialCids: ContractId<Credential>[];
};

export const useRemoveWalletsFromDenyList: () => UseMutationResult<
  void,
  string,
  RemoveWalletsFromDenyListArgs
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['removeWalletsFromClientOnboarderDenyList', ledgerApi],
    mutationFn: async ({ clientOnboarderServiceCid, denyListCid, credentialCids }) => {
      return ledgerApi.removeWalletsFromClientOnboarderDenyList(
        clientOnboarderServiceCid,
        denyListCid,
        credentialCids,
      );
    },
    retry: false,
  });
};
